if (document.querySelector('.privacy-cart #privacy_drawer') !== null && document.querySelector('.privacy-cart #privacy_drawer').checked) {
  document.querySelector('.privacy-cart #privacy_drawer').checked = false;
}

(function() {

  if (document.querySelectorAll('.privacy-cart').length) {

    document.querySelectorAll('.privacy-cart #privacy, .privacy-cart #privacy_drawer').forEach(function(element) {
      element.addEventListener('click', function () {
        if (this.checked) {
          this.closest('.cart-drawer, .cart').querySelector('button[name="checkout"]').disabled = false;
        } else {
          this.closest('.cart-drawer, .cart').querySelector('button[name="checkout"]').disabled = true;
        }
      });
    });

    document.querySelectorAll('.privacy-cart #privacy_drawer').forEach(function(element) {
      element.addEventListener('click', function () {
        if (this.checked) {
          this.closest('.cart-drawer').querySelector('button[name="checkout"]').disabled = false;
        } else {
          this.closest('.cart-drawer').querySelector('button[name="checkout"]').disabled = true;
        }
      });
    });

    if (!document.querySelector('.privacy-cart #privacy_drawer').checked) {
      document.querySelector('.cart-drawer button[name="checkout"]').disabled = true;
    } else {
      document.querySelector('.privacy-cart #privacy_drawer').checked = false;
    }
  }
  

  setTimeout(function () {
    const specTextElement = document.querySelector('#quantity-discount-app .spec_text');
    
    if (specTextElement && document.documentElement.lang === 'en') {
      let qdiscount_html = specTextElement.innerHTML;
      qdiscount_html = qdiscount_html.replace('Ab', 'For orders of');
      qdiscount_html = qdiscount_html.replace('Stück erhalten Sie einen Rabatt von', 'or more, you will receive a discount of');
      qdiscount_html = qdiscount_html.replace('off', 'per item');
      specTextElement.innerHTML = qdiscount_html;
    }
  }, 2000);


  $(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
      window.location.reload();
    }
  });
  
})();
